import {ajaxGet} from 'api/explus-api'

const Logout = () => {
  if (localStorage.getItem('token')) {
    sessionStorage.clear()
    // localStorage.clear()
    localStorage.removeItem('userId');
    localStorage.removeItem('token');
    ajaxGet('web/logout').then(dd => {
      window.location = "/"
    })
  }

  return null
}

export default Logout
